import PropTypes from 'prop-types';
import React from 'react';

// role="note" so the aside is announced as an aside. `lead` is the bolded first clause, for
// when one clause is the consequence the reader most needs and should carry the emphasis
// rather than the whole callout being loud. `page` drops it onto the page background instead
// of inside a card.
const Callout = ({ tone, page, eyebrow, lead, children, testId }) => (
  <div
    role="note"
    data-testid={testId}
    className={`od-callout od-callout--${tone}${page ? ' od-callout--page' : ''}`}
  >
    {eyebrow ? <span className="od-callout__eyebrow">{eyebrow}</span> : null}
    {lead ? <strong>{lead}</strong> : null}
    {lead && children ? ' ' : null}
    {children}
  </div>
);

Callout.propTypes = {
  tone: PropTypes.oneOf(['info', 'warning']),
  page: PropTypes.bool,
  eyebrow: PropTypes.string,
  lead: PropTypes.string,
  children: PropTypes.node,
  testId: PropTypes.string,
};

Callout.defaultProps = {
  tone: 'info',
  page: false,
  eyebrow: undefined,
  lead: undefined,
  children: null,
  testId: undefined,
};

export default Callout;
